export default __webpack_public_path__ + "static/media/rummyLogo.570ef441.png";